import { ReactElement, useEffect, useState, useRef, memo, useMemo } from 'react';
import { Upload } from '@/sub-luca-plugin/compatible-components';
import { LoadingOutlined } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { toastInQa } from '@/sub-luca-plugin/utils/qa';
import { handleTokenExample } from '@/sub-luca-plugin/utils/class-example';
import { RcFile } from 'antd/es/upload';
import { generateOssParams, getImgInfo } from '@/sub-luca-plugin/utils';

type BeforeUploadValueType = void | boolean | string | Blob | File;
interface IProps {
    pictures?: string[];
    maxCount?: number;
    children?: ReactElement;
    accept?: string;
    showUploadList?: boolean;
    onChange?: (urls: string[]) => void;
    beforeUpload?: (file: RcFile, fileList: RcFile[]) => BeforeUploadValueType | Promise<BeforeUploadValueType>;
    customRequest?: (info: any) => void;
}

const UploadPicture = ({
    accept = '.jpg, .jpeg, .png',
    pictures = [],
    children,
    maxCount = 1,
    showUploadList = false,
    onChange,
    beforeUpload,
    customRequest,
}: IProps) => {
    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);
    const tokenRef = useRef('');

    const handleChange = async (info: any) => {
        const { fileList } = info;
        setLoading(true);
        if (fileList.some(item => item.status === 'uploading')) {
            setFileList(fileList);
            return;
        }
        // 处理上传完成的文件，根据原图尺寸生成压缩参数
        const newPictures: string[] = [];
        for (const file of fileList) {
            if (file.response) {
                const url = `https://simg01.gaodunwangxiao.com/${file.response.result}`;
                // 获取图片尺寸
                const { width, height } = await getImgInfo(url);
                // 生成OSS压缩参数
                const ossParams = generateOssParams(width, height);

                newPictures.push(`${url}${ossParams}`);
            }
        }
        setLoading(false);
        setFileList([]);
        onChange?.(pictures.concat(newPictures).slice(0, 6));
    };

    const newProps = useMemo(() => {
        if (customRequest) return {};
        return {
            action: 'https://apigateway.gaodun.com/base/v1/upload/upload',
            headers: { Authentication: `${tokenRef.current}` },
            onChange: handleChange,
        };
    }, [pictures]);

    const handleadditionalPamras = (file: any) => {
        return {
            file_name: file.name,
            item_name: 'luca',
            file_type: 'file',
        };
    };

    const handleClick = () => {
        if (pictures.length < maxCount) return;
        toastInQa(`最多只能上传${maxCount}张图片`);
    };

    useEffect(() => {
        setFileList(oldFileList => {
            if (oldFileList.length > 0) {
                return oldFileList.filter(item => pictures.includes(item.url || ''));
            }
            return oldFileList;
        });
    }, [pictures]);

    useEffect(() => {
        handleTokenExample.getFronttoken().then(accessToken => {
            tokenRef.current = accessToken;
        });
    }, []);

    return (
        <Upload
            {...newProps}
            accept={accept}
            showUploadList={showUploadList}
            maxCount={maxCount}
            multiple
            fileList={fileList}
            disabled={pictures.length >= maxCount}
            data={handleadditionalPamras}
            beforeUpload={beforeUpload}
            customRequest={customRequest}
        >
            {loading ? <LoadingOutlined /> : <div onClick={handleClick}>{children}</div>}
        </Upload>
    );
};

export default memo(UploadPicture);
